import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import { Grid, Modal, Paper, Tooltip, IconButton, Divider, withStyles } from '@material-ui/core'
import { Close, InfoOutlined } from '@material-ui/icons'
import { DatePicker } from '@material-ui/pickers'
import CurrencyTextField from '@unicef/material-ui-currency-textfield'

import { Label, TextField, CleanButton, Loader, Alert, PrimaryButton, SelectField } from '../default'
import { today, yesterday, dateFormat, startOfDay, endOfDay, maskCurrency } from '../../class/utils'
import { acGetAllFilters, acPutFilter, acGetValidPlans } from '../../class/actions'

function EditFilterModal({
  classes, open, onClose,
  filterToBeEdited, editFilterError, editingFilter,
  plans, loadingPlans
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  // Filter name, description and query
  const [name, setName] = useState('')
  const [nameError, setNameError] = useState(false)
  const [nameHelperText, setNameHelperText] = useState('')
  const [description, setDescription] = useState('')

  const [registerDateOptions, setRegisterDateOptions] = useState([])
  const [dateOptions, setDateOptions] = useState([])
  const [signOptions, setSignOptions] = useState([])

  // About register date
  const [selectedRegisterDateOption, setSelectedRegisterDateOption] = useState(0)
  const [registerBegin, setRegisterBegin] = useState(yesterday())
  const [registerEnd, setRegisterEnd] = useState(today())
  const [registerDate, setRegisterDate] = useState(today())
  const [registerDays, setRegisterDays] = useState(30)
  const [registerDaysError, setRegisterDaysError] = useState(false)
  const [registerDaysHelperText, setRegisterDaysHelperText] = useState('')

  // About plans
  const [planOptions, setPlanOptions] = useState([])
  const [selectedPlanOption, setSelectedPlanOption] = useState(0)
  const [validPlans, setValidPlans] = useState([])
  const [selectedPlan, setSelectedPlan] = useState({ name: t(`modals.filters.create.plan.anyPlan`), value: 0 })

  // About consults
  const [consultsOptions, setConsultsOptions] = useState([])
  const [selectedConsultsOption, setSelectedConsultsOption] = useState(0)
  const [consultsSign, setConsultsSign] = useState(0)
  const [consultsNumber, setConsultsNumber] = useState('')
  const [consultsNumber2, setConsultsNumber2] = useState('')
  const [consultsNumberError, setConsultsNumberError] = useState(false)
  const [consultsNumberHelperText, setConsultsNumberHelperText] = useState('')

  // About consults targets
  const [consultsTargetsOptions, setConsultsTargetsOptions] = useState([])
  const [selectedConsultsTargetsOption, setSelectedConsultsTargetsOption] = useState(false)
  const [consultsTargetsSign, setConsultsTargetsSign] = useState(0)
  const [consultsTargetsNumber, setConsultsTargetsNumber] = useState('')
  const [consultsTargetsNumber2, setConsultsTargetsNumber2] = useState('')
  const [consultsTargetsError, setConsultsTargetsError] = useState(false)
  const [consultsTargetsHelperText, setConsultsTargetsHelperText] = useState('')
  const [consultsTargetsNumberError, setConsultsTargetsNumberError] = useState(false)
  const [consultsTargetsNumberHelperText, setConsultsTargetsNumberHelperText] = useState('')

  // About consults date
  const [selectedConsultsDateOption, setSelectedConsultsDateOption] = useState(0)
  const [consultsBegin, setConsultsBegin] = useState(yesterday())
  const [consultsEnd, setConsultsEnd] = useState(today())
  const [consultsLastDays, setConsultsLastDays] = useState(30)
  const [consultsLastDaysError, setConsultsLastDaysError] = useState(false)
  const [consultsLastDaysHelperText, setConsultsLastDaysHelperText] = useState('')

  // About credit purchase
  const [creditPurchasesOptions, setCreditPurchasesOptions] = useState([])
  const [selectedCreditPurchasesOption, setSelectedCreditPurchasesOption] = useState(0)
  const [creditPurchasesSign, setCreditPurchasesSign] = useState(0)
  const [creditPurchasesValue, setCreditPurchasesValue] = useState(0)
  const [creditPurchasesValue2, setCreditPurchasesValue2] = useState(0)
  const [creditPurchasesValueError, setCreditPurchasesValueError] = useState(false)
  const [creditPurchasesValueHelperText, setCreditPurchasesValueHelperText] = useState('')

  // About credit purchases date
  const [selectedCreditPurchasesDateOption, setSelectedCreditPurchasesDateOption] = useState(0)
  const [creditPurchasesBegin, setCreditPurchasesBegin] = useState(yesterday())
  const [creditPurchasesEnd, setCreditPurchasesEnd] = useState(today())
  const [creditPurchasesLastDays, setCreditPurchasesLastDays] = useState(30)
  const [creditPurchasesLastDaysError, setCreditPurchasesLastDaysError] = useState(false)
  const [creditPurchasesLastDaysHelperText, setCreditPurchasesLastDaysHelperText] = useState('')

  // About RD Station event
  const [rdEventOptions, setRdEventOptions] = useState([])
  const [selectedRdEventOption, setSelectedRdEventOption] = useState(0)
  const [rdEventName, setRdEventName] = useState('app-user-')

  // About RD Station event user enter condition
  //const [rdEventEnterOptions, setRdEventEnterOptions] = useState([])
  //const [selectedRdEventEnterOption, setSelectedRdEventEnterOption] = useState(0)

  // About RD Station events trigger frequency
  const [rdEventTriggerFrequencyOptions, setRdEventTriggerFrequencyOptions] = useState([])
  const [selectedRdEventTriggerFrequencyOption, setSelectedRdEventTriggerFrequencyOption] = useState(0)
  const [rdEventTriggerFrequencyInterval, setRdEventTriggerFrequencyInterval] = useState(30)
  const [rdEventTriggerFrequencyIntervalError, setRdEventTriggerFrequencyIntervalError] = useState(false)
  const [rdEventTriggerFrequencyIntervalHelperText, setRdEventTriggerFrequencyIntervalHelperText] = useState('')

  // About RD Station event trigger initial date
  const [rdEventTriggerBeginOptions, setRdEventTriggerBeginOptions] = useState([])
  const [selectedRdEventTriggerBeginOption, setSelectedRdEventTriggerBeginOption] = useState(0)
  const [rdEventTriggerBeginDate, setRdEventTriggerBeginDate] = useState(today().add(2, 'days'))

  useEffect(() => {

    setDateOptions([
      { name: t(`modals.filters.create.date.doesntMatter`), value: 0 },
      { name: t(`modals.filters.create.date.period`), value: 1 },
      { name: t(`modals.filters.create.date.lastDays`), value: 2 }
    ])

    setRegisterDateOptions([
      { name: t(`modals.filters.create.date.doesntMatter`), value: 0 },
      { name: t(`modals.filters.create.date.period`), value: 1 },
      { name: t(`modals.filters.create.date.lastDays`), value: 2 },
      { name: t(`modals.filters.create.date.daysAgo`), value: 3 },
      { name: t(`modals.filters.create.date.before`), value: 4 },
      { name: t(`modals.filters.create.date.after`), value: 5 }
    ])

    setSignOptions([
      { name: t(`modals.filters.create.sign.moreThan`), value: 0 },
      { name: t(`modals.filters.create.sign.moreOrEqualTo`), value: 1 },
      { name: t(`modals.filters.create.sign.lessThan`), value: 2 },
      { name: t(`modals.filters.create.sign.lessOrEqualTo`), value: 3 },
      { name: t(`modals.filters.create.sign.equal`), value: 4 },
      { name: t(`modals.filters.create.sign.between`), value: 5 }
    ])

    setPlanOptions([
      { name: t(`modals.filters.create.plan.doesntMatter`), value: 0 },
      { name: t(`modals.filters.create.plan.activePlan`), value: 1 },
      { name: t(`modals.filters.create.plan.noActivePlan`), value: 2 }
    ])

    setConsultsOptions([
      { name: t(`modals.filters.create.consults.doesntMatter`), value: 0 },
      { name: t(`modals.filters.create.consults.withConsults`), value: 1 },
      { name: t(`modals.filters.create.consults.noConsults`), value: 2 }
    ])

    setConsultsTargetsOptions([
      { name: t(`modals.filters.create.consults.doesntMatter`), value: false },
      { name: t(`modals.filters.create.consults.itMatters`), value: true }
    ])

    setCreditPurchasesOptions([
      { name: t(`modals.filters.create.creditPurchase.doesntMatter`), value: 0 },
      { name: t(`modals.filters.create.creditPurchase.withCreditPurchase`), value: 1 },
      { name: t(`modals.filters.create.creditPurchase.noCreditPurchase`), value: 2 }
    ])

    setRdEventOptions([
      { name: t(`modals.filters.create.rdEvents.no`), value: 0 },
      { name: t(`modals.filters.create.rdEvents.yes`), value: 1 }
    ])

    /**setRdEventEnterOptions([
      { name: t(`modals.filters.create.rdEventsEnter.newUsers`), value: 0 },
      { name: t(`modals.filters.create.rdEventsEnter.allUsers`), value: 1 }
    ])*/

    setRdEventTriggerFrequencyOptions([
      { name: t(`modals.filters.create.rdEventsTriggerFrequency.everyDay`), value: 0 },
      { name: t(`modals.filters.create.rdEventsTriggerFrequency.interval`), value: 1 }
    ])

    setRdEventTriggerBeginOptions([
      { name: t(`modals.filters.create.rdEventsTriggerInitialDate.tomorrow`), value: 0 },
      { name: t(`modals.filters.create.rdEventsTriggerInitialDate.anotherDay`), value: 1 }
    ])

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!plans)
      dispatch(acGetValidPlans())
    else {
      let firstOption = [{
        name: t(`modals.filters.create.plan.anyPlan`),
        value: 0
      }]
      let plansList = plans.map(plan => ({
        name: plan.name,
        value: plan.plan_id
      }))

      setValidPlans([...firstOption, ...plansList])
    }
  }, [t, dispatch, plans])

  useEffect(() => {
    setFilterDescription()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedRegisterDateOption, registerBegin, registerEnd, registerDate, registerDays,
    selectedPlanOption, selectedPlan,
    selectedConsultsOption, consultsSign, consultsNumber, consultsNumber2,
    selectedConsultsTargetsOption, consultsTargetsSign, consultsTargetsNumber, consultsTargetsNumber2,
    selectedConsultsDateOption, consultsBegin, consultsEnd, consultsLastDays,
    selectedCreditPurchasesOption, creditPurchasesSign, creditPurchasesValue, creditPurchasesValue2,
    selectedCreditPurchasesDateOption, creditPurchasesBegin, creditPurchasesEnd, creditPurchasesLastDays
  ])

  useEffect(() => {

    setName(filterToBeEdited.name)
    setDescription(filterToBeEdited.description)

    // About register date
    if (filterToBeEdited.register_period_begin && filterToBeEdited.register_period_end) {
      setSelectedRegisterDateOption(1)
      setRegisterBegin(new Date(filterToBeEdited.register_period_begin))
      setRegisterEnd(new Date(filterToBeEdited.register_period_end))
    } else if (filterToBeEdited.register_last_days) {
      setSelectedRegisterDateOption(2)
      setRegisterDays(filterToBeEdited.register_last_days)
    } else if (filterToBeEdited.register_days_ago) {
      setSelectedRegisterDateOption(3)
      setRegisterDays(filterToBeEdited.register_days_ago)
    } else if (filterToBeEdited.register_period_begin && !filterToBeEdited.register_period_end) {
      setSelectedRegisterDateOption(4)
      setRegisterDate(new Date(filterToBeEdited.register_period_begin))
    } else if (!filterToBeEdited.register_period_begin && filterToBeEdited.register_period_end) {
      setSelectedRegisterDateOption(5)
      setRegisterDate(new Date(filterToBeEdited.register_period_end))
    }

    // About plans
    if (filterToBeEdited.desire_plan_situation) {
      if (filterToBeEdited.active_plan) {
        setSelectedPlanOption(1)
        if (filterToBeEdited.active_plan !== -1) {
          let plan = plans.find(plan => plan.plan_id === filterToBeEdited.active_plan)
          setSelectedPlan({ name: plan.name, value: filterToBeEdited.active_plan })
        }
      } else
        setSelectedPlanOption(2)
    }

    // About consults
    if (filterToBeEdited.desire_consult_situation) {
      if (filterToBeEdited.consults_number) {
        setSelectedConsultsOption(1)
        if (filterToBeEdited.consults_number !== -1) {
          setConsultsSign(filterToBeEdited.consults_sign)
          setConsultsNumber(filterToBeEdited.consults_number)
          if (filterToBeEdited.consults_sign === 5)
            setConsultsNumber2(filterToBeEdited.consults_number_2)
        }
      } else
        setSelectedConsultsOption(2)

      // About consults targets
      if (filterToBeEdited.desire_different_targets_consult_situation) {
        setSelectedConsultsTargetsOption(true)
        setConsultsTargetsSign(filterToBeEdited.different_targets_consult_sign)
        setConsultsTargetsNumber(filterToBeEdited.desire_different_targets_consult_situation)
        if (filterToBeEdited.different_targets_consult_sign === 5)
          setConsultsTargetsNumber2(filterToBeEdited.different_targets_consult_number_2)
      }
    }

    // About consults date
    if (filterToBeEdited.consult_period_begin && filterToBeEdited.consult_period_end) {
      setSelectedConsultsDateOption(1)
      setConsultsBegin(new Date(filterToBeEdited.consult_period_begin))
      setConsultsEnd(new Date(filterToBeEdited.consult_period_end))
    } else if (filterToBeEdited.consult_last_days) {
      setSelectedConsultsDateOption(2)
      setConsultsLastDays(filterToBeEdited.consult_last_days)
    }

    // About credit purchase
    if (filterToBeEdited.desire_credit_purchase_situation) {
      if (filterToBeEdited.credit_purchase_value) {
        setSelectedCreditPurchasesOption(1)
        if (filterToBeEdited.credit_purchase_value !== -1) {
          setCreditPurchasesSign(filterToBeEdited.credit_purchase_sign)
          setCreditPurchasesValue(filterToBeEdited.credit_purchase_value)
          if (filterToBeEdited.credit_purchase_sign === 5)
            setCreditPurchasesValue2(filterToBeEdited.credit_purchase_value_2)
        }
      } else
        setSelectedCreditPurchasesOption(2)
    }

    // About credit purchase date
    if (filterToBeEdited.credit_purchase_period_begin && filterToBeEdited.credit_purchase_period_end) {
      setSelectedCreditPurchasesDateOption(1)
      setCreditPurchasesBegin(new Date(filterToBeEdited.credit_purchase_period_begin))
      setCreditPurchasesEnd(new Date(filterToBeEdited.credit_purchase_period_end))
    } else if (filterToBeEdited.credit_purchase_last_days) {
      setSelectedCreditPurchasesDateOption(2)
      setCreditPurchasesLastDays(filterToBeEdited.credit_purchase_last_days)
    }

    // About RD Station event
    if (filterToBeEdited.rd_event_id) {
      setRdEventName(filterToBeEdited.rdEvent.name)
      setSelectedRdEventOption(1)
      if (filterToBeEdited.rdEvent.trigger_frequency_interval !== 1) {
        setSelectedRdEventTriggerFrequencyOption(1)
        setRdEventTriggerFrequencyInterval(filterToBeEdited.rdEvent.trigger_frequency_interval)
      }
      if (filterToBeEdited.rdEvent.trigger_initial_date) {
        setSelectedRdEventTriggerBeginOption(1)
        setRdEventTriggerBeginDate(new Date(`${filterToBeEdited.rdEvent.trigger_initial_date}T03:00:00`))
      }
    }

  }, [open, plans, filterToBeEdited])

  const validateName = value => {
    setName(value)
    setRdEventName(`app-user-${value.toLowerCase().replace(/[^a-z0-9\s]/gi, '').replace(/\s+/g, '-')}`)
    setNameError(false)
    setNameHelperText('')
  }

  const validateRegisterDays = value => {
    if (value === "") {
      setRegisterDays(value)
      setRegisterDaysError(true)
      setRegisterDaysHelperText(t('modals.filters.create.date.errorText'))
      return
    }
    const positiveValue = parseInt(+value)
    if (positiveValue < 1)
      setRegisterDays(1)
    else
      setRegisterDays(positiveValue)

    setRegisterDaysError(false)
    setRegisterDaysHelperText('')
  }

  const validateConsultsNumber = (value, firstOrSecond) => {

    if (firstOrSecond === 1) {

      if (value === "") {
        setConsultsNumber(value)
        setConsultsNumber2(value)
        setConsultsNumberError(false)
        setConsultsNumberHelperText('')
        return
      }
      const positiveValue = parseInt(+value)
      if (positiveValue < 1)
        setConsultsNumber(1)
      else
        setConsultsNumber(positiveValue)

      if (consultsNumber2.length === 0) {
        setConsultsNumberError(true)
        setConsultsNumberHelperText(t('modals.filters.create.consults.errorText'))
      }
      else if (consultsNumber2 <= positiveValue) {
        setConsultsNumberError(true)
        setConsultsNumberHelperText(t('modals.filters.create.consults.errorText2'))
      } else {
        setConsultsNumberError(false)
        setConsultsNumberHelperText('')
      }

    } else {

      if (value === "") {
        setConsultsNumber2(value)
        setConsultsNumberError(true)
        setConsultsNumberHelperText(t('modals.filters.create.consults.errorText'))
        return
      }
      const positiveValue = parseInt(+value)
      if (positiveValue < 1)
        setConsultsNumber2(1)
      else
        setConsultsNumber2(positiveValue)

      if (positiveValue <= consultsNumber) {
        setConsultsNumberError(true)
        setConsultsNumberHelperText(t('modals.filters.create.consults.errorText2'))
      } else {
        setConsultsNumberError(false)
        setConsultsNumberHelperText('')
      }

    }

  }

  const validateConsultsTargetsNumber = (value, firstOrSecond) => {

    if (firstOrSecond === 1) {

      if (value === "") {
        setConsultsTargetsNumber(value)
        setConsultsTargetsNumber2(value)
        setConsultsTargetsNumberError(false)
        setConsultsTargetsNumberHelperText('')
        return
      }
      const positiveValue = parseInt(+value)
      if (positiveValue < 1)
        setConsultsTargetsNumber(1)
      else
        setConsultsTargetsNumber(positiveValue)

      if (consultsTargetsNumber2.length === 0) {
        setConsultsTargetsNumberError(true)
        setConsultsTargetsNumberHelperText(t('modals.filters.create.consultsTargets.errorText2'))
      }
      else if (consultsTargetsNumber2 <= positiveValue) {
        setConsultsTargetsNumberError(true)
        setConsultsTargetsNumberHelperText(t('modals.filters.create.consultsTargets.errorText3'))
      } else {
        setConsultsTargetsNumberError(false)
        setConsultsTargetsNumberHelperText('')
      }

      setConsultsTargetsError(false)
      setConsultsTargetsHelperText('')

    } else {

      if (value === "") {
        setConsultsTargetsNumber2(value)
        setConsultsTargetsNumberError(true)
        setConsultsTargetsNumberHelperText(t('modals.filters.create.consultsTargets.errorText2'))
        return
      }
      const positiveValue = parseInt(+value)
      if (positiveValue < 1)
        setConsultsTargetsNumber2(1)
      else
        setConsultsTargetsNumber2(positiveValue)

      if (positiveValue <= consultsTargetsNumber) {
        setConsultsTargetsNumberError(true)
        setConsultsTargetsNumberHelperText(t('modals.filters.create.consultsTargets.errorText3'))
      } else {
        setConsultsTargetsNumberError(false)
        setConsultsTargetsNumberHelperText('')
      }

    }

  }

  const validateConsultsDays = value => {
    if (value === "") {
      setConsultsLastDays(value)
      setConsultsLastDaysError(true)
      setConsultsLastDaysHelperText(t('modals.filters.create.date.errorText'))
      return
    }
    const positiveValue = parseInt(+value)
    if (positiveValue < 1)
      setConsultsLastDays(1)
    else
      setConsultsLastDays(positiveValue)

    setConsultsLastDaysError(false)
    setConsultsLastDaysHelperText('')
  }

  const validateCreditPurchasesValue = (value, firstOrSecond) => {
    if (firstOrSecond === 1) {

      if (value === '' || value === 0) {
        setCreditPurchasesValue('')
        setCreditPurchasesValue2('')
        setCreditPurchasesValueError(false)
        setCreditPurchasesValueHelperText('')
        return
      }

      setCreditPurchasesValue(value)

      if (creditPurchasesValue2.length === 0) {
        setCreditPurchasesValueError(true)
        setCreditPurchasesValueHelperText(t('modals.filters.create.creditPurchase.errorText'))
      }
      else if (creditPurchasesValue2 <= value) {
        setCreditPurchasesValueError(true)
        setCreditPurchasesValueHelperText(t('modals.filters.create.creditPurchase.errorText2'))
      } else {
        setCreditPurchasesValueError(false)
        setCreditPurchasesValueHelperText('')
      }

    } else {

      if (value === '' || value === 0) {
        setCreditPurchasesValue2('')
        setCreditPurchasesValueError(true)
        setCreditPurchasesValueHelperText(t('modals.filters.create.creditPurchase.errorText'))
        return
      }

      setCreditPurchasesValue2(value)

      if (value <= creditPurchasesValue) {
        setCreditPurchasesValueError(true)
        setCreditPurchasesValueHelperText(t('modals.filters.create.creditPurchase.errorText2'))
      } else {
        setCreditPurchasesValueError(false)
        setCreditPurchasesValueHelperText('')
      }

    }
  }

  const validateCreditPurchasesDays = value => {
    if (value === "") {
      setCreditPurchasesLastDays(value)
      setCreditPurchasesLastDaysError(true)
      setCreditPurchasesLastDaysHelperText(t('modals.filters.create.date.errorText'))
      return
    }
    const positiveValue = parseInt(+value)
    if (positiveValue < 1)
      setCreditPurchasesLastDays(1)
    else
      setCreditPurchasesLastDays(positiveValue)

    setCreditPurchasesLastDaysError(false)
    setCreditPurchasesLastDaysHelperText('')
  }

  const validateRdEventTriggerFrequencyInterval = value => {
    if (value === "") {
      setRdEventTriggerFrequencyInterval(value)
      setRdEventTriggerFrequencyIntervalError(true)
      setRdEventTriggerFrequencyIntervalHelperText(t('modals.filters.create.rdEventsTriggerFrequency.errorText'))
      return
    }
    const positiveValue = parseInt(+value)
    if (positiveValue < 1)
      setRdEventTriggerFrequencyInterval(1)
    else
      setRdEventTriggerFrequencyInterval(positiveValue)

    setRdEventTriggerFrequencyIntervalError(false)
    setRdEventTriggerFrequencyIntervalHelperText('')
  }

  const setInicialState = () => {
    setName('')
    setNameError(false)
    setNameHelperText('')
    setDescription('')

    setSelectedRegisterDateOption(0)
    setRegisterBegin(yesterday())
    setRegisterEnd(today())
    setRegisterDate(today())
    setRegisterDays(30)
    setRegisterDaysError(false)
    setRegisterDaysHelperText('')

    setSelectedPlanOption(0)
    setSelectedPlan({ name: t(`modals.filters.create.plan.anyPlan`), value: 0 })

    setSelectedConsultsOption(0)
    setConsultsSign(0)
    setConsultsNumber('')
    setConsultsNumber2('')
    setConsultsNumberError(false)
    setConsultsNumberHelperText('')

    setSelectedConsultsTargetsOption(false)
    setConsultsTargetsSign(0)
    setConsultsTargetsNumber('')
    setConsultsTargetsNumber2('')
    setConsultsTargetsError(false)
    setConsultsTargetsHelperText('')
    setConsultsTargetsNumberError(false)
    setConsultsTargetsNumberHelperText('')

    setSelectedConsultsDateOption(0)
    setConsultsBegin(yesterday())
    setConsultsEnd(today())
    setConsultsLastDays(30)
    setConsultsLastDaysError(false)
    setConsultsLastDaysHelperText('')

    setSelectedCreditPurchasesOption(0)
    setCreditPurchasesSign(0)
    setCreditPurchasesValue(0)
    setCreditPurchasesValue2(0)
    setCreditPurchasesValueError(false)
    setCreditPurchasesValueHelperText('')

    setSelectedCreditPurchasesDateOption(0)
    setCreditPurchasesBegin(yesterday())
    setCreditPurchasesEnd(today())
    setCreditPurchasesLastDays(30)
    setCreditPurchasesLastDaysError(false)
    setCreditPurchasesLastDaysHelperText('')

    setSelectedRdEventOption(0)
    setRdEventName('app-user-')

    setSelectedRdEventTriggerFrequencyOption(0)
    setRdEventTriggerFrequencyInterval(30)
    setRdEventTriggerFrequencyIntervalError(false)
    setRdEventTriggerFrequencyIntervalHelperText('')

    setSelectedRdEventTriggerBeginOption(0)
    setRdEventTriggerBeginDate(today().add(2, 'days'))

    dispatch(acGetAllFilters())
      .catch(err => console.error(err))
    onClose()
  }

  const setFilterDescription = () => {

    let description = ["Usuários"]

    // About register date
    if (selectedRegisterDateOption === 1)
      description.push("cadastrados no período de " + dateFormat(registerBegin, true) + " a " + dateFormat(registerEnd, true))
    else if (selectedRegisterDateOption === 2)
      description.push("cadastrados nos últimos " + registerDays + " dias")
    else if (selectedRegisterDateOption === 3)
      description.push("cadastrados há " + registerDays + " dias")
    else if (selectedRegisterDateOption === 4)
      description.push("cadastrados antes ou na data de " + dateFormat(registerDate, true))
    else if (selectedRegisterDateOption === 5)
      description.push("cadastrados na data ou depois de " + dateFormat(registerDate, true))

    // About plans
    if (selectedPlanOption === 1) {
      if (selectedPlan.value === 0)
        description.push("com plano ativo")
      else
        description.push("com o plano " + selectedPlan.name + " ativo")
    } else if (selectedPlanOption === 2)
      description.push("sem plano ativo")

    // About consults
    if (selectedConsultsOption === 1) {

      if (consultsNumber.length === 0)
        description.push("que realizaram consultas")
      else {
        switch (consultsSign) {
          case 0:
            description.push(`que realizaram mais que ${consultsNumber} consultas`)
            break
          case 1:
            description.push(`que realizaram ${consultsNumber} ou mais consultas`)
            break
          case 2:
            description.push(`que realizaram menos que ${consultsNumber} consultas`)
            break
          case 3:
            description.push(`que realizaram ${consultsNumber} ou menos consultas`)
            break
          case 4:
            description.push(`que realizaram ${consultsNumber} consultas`)
            break
          case 5:
            description.push(`que realizaram entre ${consultsNumber} e ${consultsNumber2} consultas`)
            break
          default:
            description.push(`que realizaram consultas`)
        }
      }

      // About consults targets
      if (selectedConsultsTargetsOption === true && consultsTargetsNumber.length !== 0) {

        switch (consultsTargetsSign) {
          case 0:
            description[description.length - 1] = description[description.length - 1] + ` com mais de ${consultsTargetsNumber} CPFs ou CNPJs diferentes`
            break
          case 1:
            description[description.length - 1] = description[description.length - 1] + ` com ${consultsTargetsNumber} ou mais CPFs ou CNPJs diferentes`
            break
          case 2:
            description[description.length - 1] = description[description.length - 1] + ` com menos de ${consultsTargetsNumber} CPFs ou CNPJs diferentes`
            break
          case 3:
            description[description.length - 1] = description[description.length - 1] + ` com ${consultsTargetsNumber} ou menos CPFs ou CNPJs diferentes`
            break
          case 4:
            description[description.length - 1] = description[description.length - 1] + ` com ${consultsTargetsNumber} CPFs ou CNPJs diferentes`
            break
          case 5:
            description[description.length - 1] = description[description.length - 1] + ` com ${consultsTargetsNumber} a ${consultsTargetsNumber2} CPFs ou CNPJs diferentes`
            break
          default:
            break
        }

      }

    } else if (selectedConsultsOption === 2)
      description.push("que não realizaram consultas")

    // About consults date
    if (selectedConsultsOption !== 0) {
      if (selectedConsultsDateOption === 1)
        description[description.length - 1] = description[description.length - 1] + " no período de " + dateFormat(consultsBegin, true) + " a " + dateFormat(consultsEnd, true)
      else if (selectedConsultsDateOption === 2)
        description[description.length - 1] = description[description.length - 1] + " nos últimos " + consultsLastDays + " dias"
    }

    // About credit purchase
    if (selectedCreditPurchasesOption === 1) {

      if (creditPurchasesValue.length === 0 || creditPurchasesValue === 0)
        description.push("que compraram créditos avulsos")
      else {
        switch (creditPurchasesSign) {
          case 0:
            description.push(`que compraram mais que ${maskCurrency(creditPurchasesValue)} em créditos avulsos`)
            break
          case 1:
            description.push(`que compraram ${maskCurrency(creditPurchasesValue)} ou mais em créditos avulsos`)
            break
          case 2:
            description.push(`que compraram menos que ${maskCurrency(creditPurchasesValue)} em créditos avulsos`)
            break
          case 3:
            description.push(`que compraram ${maskCurrency(creditPurchasesValue)} ou menos em créditos avulsos`)
            break
          case 4:
            description.push(`que compraram ${maskCurrency(creditPurchasesValue)} em créditos avulsos`)
            break
          case 5:
            description.push(`que compraram entre ${maskCurrency(creditPurchasesValue)} e ${maskCurrency(creditPurchasesValue2)} em créditos avulsos`)
            break
          default:
            description.push(`que compraram créditos avulsos`)
        }
      }

    } else if (selectedCreditPurchasesOption === 2)
      description.push("que não compraram créditos avulsos")

    // About credit purchase date
    if (selectedCreditPurchasesOption !== 0) {
      if (selectedCreditPurchasesDateOption === 1)
        description[description.length - 1] = description[description.length - 1] + " no período de " + dateFormat(creditPurchasesBegin, true) + " a " + dateFormat(creditPurchasesEnd, true)
      else if (selectedCreditPurchasesDateOption === 2)
        description[description.length - 1] = description[description.length - 1] + " nos últimos " + creditPurchasesLastDays + " dias"
    }

    description.push('.')

    setDescription(description.slice(0, -1).join(', ') + description.slice(-1))
  }

  const editFilter = () => {

    if (name.length === 0) {
      setNameError(true)
      setNameHelperText(t('modals.filters.create.name.errorText'))
      return
    }

    if ((selectedRegisterDateOption === 2 || selectedRegisterDateOption === 3) && registerDaysError)
      return

    if (selectedConsultsOption === 1 && consultsSign === 5 && consultsNumberError)
      return

    if (selectedConsultsTargetsOption === true && consultsTargetsNumber.length === 0) {
      setConsultsTargetsError(true)
      setConsultsTargetsHelperText(t('modals.filters.create.consultsTargets.errorText'))
      return
    }

    if (selectedConsultsTargetsOption === true && consultsTargetsSign === 5 && consultsTargetsNumberError)
      return

    if (selectedConsultsDateOption && consultsLastDaysError)
      return

    if (selectedCreditPurchasesOption === 1 && creditPurchasesSign === 5 && creditPurchasesValueError)
      return

    if (selectedCreditPurchasesDateOption && creditPurchasesLastDaysError)
      return

    if (selectedRdEventOption === 1 && selectedRdEventTriggerFrequencyOption === 1 && rdEventTriggerFrequencyIntervalError)
      return

    var register_period_begin = null
    var register_period_end = null
    var register_last_days = null
    var register_days_ago = null

    var desire_plan_situation = false
    var active_plan = null

    var desire_consult_situation = false
    var consults_sign = 0
    var consults_number = null
    var consults_number_2 = null

    var consult_period_begin = null
    var consult_period_end = null
    var consult_last_days = null

    var desire_different_targets_consult_situation = null
    var different_targets_consult_sign = 0
    var different_targets_consult_number_2 = null

    var desire_credit_purchase_situation = false
    var credit_purchase_sign = 0
    var credit_purchase_value = null
    var credit_purchase_value_2 = null

    var credit_purchase_period_begin = null
    var credit_purchase_period_end = null
    var credit_purchase_last_days = null

    var rd_event_name = null
    var rd_event_trigger_frequency_interval = 1
    var rd_event_trigger_initial_date = null

    if (selectedRegisterDateOption === 1) {
      register_period_begin = startOfDay(registerBegin).toISOString().replace('T', ' ').split('.')[0]
      register_period_end = endOfDay(registerEnd).toISOString().replace('T', ' ').split('.')[0]
    }
    else if (selectedRegisterDateOption === 2)
      register_last_days = registerDays
    else if (selectedRegisterDateOption === 3)
      register_days_ago = registerDays
    else if (selectedRegisterDateOption === 4)
      register_period_begin = startOfDay(registerDate).toISOString().replace('T', ' ').split('.')[0]
    else if (selectedRegisterDateOption === 5)
      register_period_end = endOfDay(registerDate).toISOString().replace('T', ' ').split('.')[0]


    if (selectedPlanOption !== 0) {
      desire_plan_situation = true
      if (selectedPlanOption === 1) {
        if (selectedPlan.value === 0)
          active_plan = -1
        else
          active_plan = selectedPlan.value
      }
    }

    if (selectedConsultsOption !== 0) {
      desire_consult_situation = true

      if (selectedConsultsOption === 1) {

        if (consultsNumber.length === 0)
          consults_number = -1
        else {
          consults_sign = consultsSign
          consults_number = consultsNumber
          if (consultsSign === 5)
            consults_number_2 = consultsNumber2
        }

        if (selectedConsultsTargetsOption === true && consultsTargetsNumber.length !== 0) {
          different_targets_consult_sign = consultsTargetsSign
          desire_different_targets_consult_situation = consultsTargetsNumber
          if (consultsTargetsSign === 5)
            different_targets_consult_number_2 = consultsTargetsNumber2
        }
      }

      if (selectedConsultsDateOption === 1) {
        consult_period_begin = startOfDay(consultsBegin).toISOString().replace('T', ' ').split('.')[0]
        consult_period_end = endOfDay(consultsEnd).toISOString().replace('T', ' ').split('.')[0]
      } else if (selectedConsultsDateOption === 2)
        consult_last_days = consultsLastDays
    }

    if (selectedCreditPurchasesOption !== 0) {
      desire_credit_purchase_situation = true

      if (selectedCreditPurchasesOption === 1) {
        if (creditPurchasesValue.length === 0 || creditPurchasesValue === 0)
          credit_purchase_value = -1
        else {
          credit_purchase_sign = creditPurchasesSign
          credit_purchase_value = creditPurchasesValue
          if (creditPurchasesSign === 5)
            credit_purchase_value_2 = creditPurchasesValue2
        }
      }

      if (selectedCreditPurchasesDateOption === 1) {
        credit_purchase_period_begin = startOfDay(creditPurchasesBegin).toISOString().replace('T', ' ').split('.')[0]
        credit_purchase_period_end = endOfDay(creditPurchasesEnd).toISOString().replace('T', ' ').split('.')[0]
      } else if (selectedCreditPurchasesDateOption === 2)
        credit_purchase_last_days = creditPurchasesLastDays

    }

    if (selectedRdEventOption === 1) {
      rd_event_name = rdEventName
      if (selectedRdEventTriggerFrequencyOption === 1)
        rd_event_trigger_frequency_interval = rdEventTriggerFrequencyInterval
      if (selectedRdEventTriggerBeginOption === 1)
        rd_event_trigger_initial_date = startOfDay(rdEventTriggerBeginDate).toISOString().replace('T', ' ').split('.')[0]
    }

    dispatch(acPutFilter(
      filterToBeEdited.filter_id,
      name,
      description,

      register_period_begin,
      register_period_end,
      register_last_days,
      register_days_ago,

      desire_plan_situation,
      active_plan,

      desire_consult_situation,
      consults_sign,
      consults_number,
      consults_number_2,

      consult_period_begin,
      consult_period_end,
      consult_last_days,

      desire_different_targets_consult_situation,
      different_targets_consult_sign,
      different_targets_consult_number_2,

      desire_credit_purchase_situation,
      credit_purchase_sign,
      credit_purchase_value,
      credit_purchase_value_2,

      credit_purchase_period_begin,
      credit_purchase_period_end,
      credit_purchase_last_days,

      rd_event_name,
      rd_event_trigger_frequency_interval,
      rd_event_trigger_initial_date
    ))
      .then(() => {
        setInicialState()
        dispatch(acGetAllFilters())
          .catch(err => console.error(err))
        onClose()
      })
      .catch(err => console.error(err))

  }

  return (
    <Modal open={open} onClose={onClose} disableAutoFocus style={{ outline: 0, overflowY: 'scroll' }}>
      <Paper
        square={true}
        className={classes.root + ' ' + classes.modalDiv}
      >
        <Grid container spacing={2} justify='center'>

          {/** Title */}
          <Grid container justify='space-between' alignItems='center' item xs={12}>
            <Grid item>
              <Label v='h6'>
                {t('modals.filters.edit.title')}
              </Label>
            </Grid>
            <Grid item>
              <Tooltip title={t('default.close')}>
                <IconButton onClick={onClose}>
                  <Close />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>

          {/** Filter name */}
          <Grid container spacing={2} item xs={12}>

            <Grid item xs={2}>
              <Label v='body2'>
                {t('modals.filters.create.name.label')}
              </Label>
            </Grid>

            <Grid item xs={10}>
              <TextField
                light
                variant='filled'
                type='text'
                label={t('modals.filters.create.name.label')}
                value={name}
                onChange={e => validateName(e.target.value)}
                error={nameError}
                helperText={nameHelperText}
                style={{ width: '100%' }}
                inputProps={{
                  maxLength: 100
                }}
              />
            </Grid>

          </Grid>

          {/** Filter description */}
          <Grid container spacing={2} item xs={12}>

            <Grid item xs={2}>
              <Label v='body2'>
                {t('modals.filters.create.description.label')}
                <Tooltip title={t('modals.filters.create.description.tooltip')} placement="right" style={{ marginLeft: '5px' }}>
                  <InfoOutlined fontSize='small' />
                </Tooltip>
              </Label>
            </Grid>

            <Grid item xs={10}>
              <TextField
                light
                variant='filled'
                type='text'
                multiline
                rows={3}
                label={t('modals.filters.create.description.label')}
                value={description}
                style={{ width: '100%' }}
                inputProps={{
                  readOnly: true
                }}
              />
            </Grid>

          </Grid>

          {/** About register date */}
          <Grid container spacing={2} item xs={12}>

            <Grid item xs={2}>
              <Label v='body2'>
                {t('modals.filters.create.register.label')}
              </Label>
            </Grid>

            <Grid item xs={3}>
              <SelectField
                label={t('modals.filters.create.register.label')}
                items={registerDateOptions}
                value={selectedRegisterDateOption}
                onChange={e => setSelectedRegisterDateOption(e.target.value)}
              />
            </Grid>

            {
              selectedRegisterDateOption === 1
                ? (
                  <>
                    <Grid item xs={3} md={2}>
                      <DatePicker
                        label={t('modals.filters.create.register.begin')}
                        inputVariant="outlined"
                        format="dd/MM/yyyy"
                        value={registerBegin}
                        onChange={e => setRegisterBegin(e)}
                        maxDate={registerEnd}
                        showTodayButton
                        todayLabel={t('modals.notifications.create.validUntil.today')}
                        required
                        style={{ width: '100%' }}
                      />
                    </Grid>
                    <Grid item xs={3} md={2}>
                      <DatePicker
                        label={t('modals.filters.create.register.end')}
                        inputVariant="outlined"
                        format="dd/MM/yyyy"
                        value={registerEnd}
                        onChange={e => setRegisterEnd(e)}
                        minDate={registerBegin}
                        disableFuture
                        showTodayButton
                        todayLabel={t('modals.notifications.create.validUntil.today')}
                        required
                        style={{ width: '100%' }}
                      />
                    </Grid>
                  </>
                )
                : (selectedRegisterDateOption === 2 || selectedRegisterDateOption === 3)
                  ? (
                    <Grid item xs={3} md={2}>
                      <TextField
                        light
                        variant='filled'
                        type="number"
                        min={0}
                        label={t('modals.filters.create.register.days')}
                        value={registerDays}
                        error={registerDaysError}
                        helperText={registerDaysHelperText}
                        onChange={e => validateRegisterDays(e.target.value)}
                        style={{ width: '100%' }}
                      />
                    </Grid>
                  )
                  : (selectedRegisterDateOption === 4 || selectedRegisterDateOption === 5) && (
                    <Grid item xs={3} md={2}>
                      <DatePicker
                        label={t('modals.filters.create.register.date')}
                        inputVariant="outlined"
                        format="dd/MM/yyyy"
                        value={registerDate}
                        onChange={e => setRegisterDate(e)}
                        showTodayButton
                        todayLabel={t('modals.notifications.create.validUntil.today')}
                        required
                        style={{ width: '100%' }}
                      />
                    </Grid>
                  )
            }

          </Grid>

          {/** About plans */}
          <Grid container spacing={2} item xs={12}>

            <Grid item xs={2}>
              <Label v='body2'>
                {t('modals.filters.create.plan.label')}
              </Label>
            </Grid>

            <Grid item xs={3}>
              <SelectField
                label={t('modals.filters.create.plan.label')}
                items={planOptions}
                value={selectedPlanOption}
                onChange={e => setSelectedPlanOption(e.target.value)}
              />
            </Grid>

            {
              (loadingPlans || !plans)
                ? <Loader />
                : selectedPlanOption === 1 && (
                  <Grid item xs={4}>
                    <SelectField
                      label={t('modals.filters.create.plan.plan')}
                      items={validPlans}
                      value={selectedPlan.value}
                      onChange={e => setSelectedPlan({ name: e.currentTarget.getAttribute('name'), value: e.target.value })}
                      style={{ width: '100%' }}
                    />
                  </Grid>
                )
            }

          </Grid>

          {/** About consults */}
          <Grid container spacing={2} item xs={12}>

            <Grid item xs={2}>
              <Label v='body2'>
                {t('modals.filters.create.consults.label')}
              </Label>
            </Grid>

            <Grid item xs={3}>
              <SelectField
                label={t('modals.filters.create.consults.label')}
                items={consultsOptions}
                value={selectedConsultsOption}
                onChange={e => setSelectedConsultsOption(e.target.value)}
              />
            </Grid>

            {
              selectedConsultsOption === 1 && (
                <>
                  <Grid item xs={3} md={2}>
                    <SelectField
                      label={t('modals.filters.create.sign.label')}
                      items={signOptions}
                      value={consultsSign}
                      onChange={e => setConsultsSign(e.target.value)}
                      style={{ width: '100%' }}
                    />
                  </Grid>
                  <Grid item xs={3} md={2}>
                    <TextField
                      light
                      variant='filled'
                      type='number'
                      label={consultsSign === 5 ? t('modals.filters.create.sign.minimumQuantity') : t('modals.filters.create.sign.quantity')}
                      value={consultsNumber}
                      onChange={e => validateConsultsNumber(e.target.value, 1)}
                      style={{ width: '100%' }}
                    />
                  </Grid>
                  {
                    consultsSign === 5 && (
                      <Grid item xs={3} md={2}>
                        <TextField
                          light
                          variant='filled'
                          type='number'
                          label={t('modals.filters.create.sign.maximumQuantity')}
                          value={consultsNumber2}
                          onChange={e => validateConsultsNumber(e.target.value, 2)}
                          disabled={consultsNumber.length === 0}
                          error={consultsNumberError}
                          helperText={consultsNumberHelperText}
                          style={{ width: '100%' }}
                        />
                      </Grid>
                    )
                  }
                </>
              )

            }

          </Grid>

          {/** About consults targets */}
          {
            selectedConsultsOption === 1 && (
              <Grid container spacing={2} item xs={12}>

                <Grid item xs={2}>
                  <Label v='body2'>
                    {t('modals.filters.create.consultsTargets.label')}
                    <Tooltip title={t('modals.filters.create.consultsTargets.tooltip')} placement="right" style={{ marginLeft: '5px' }}>
                      <InfoOutlined fontSize='small' />
                    </Tooltip>
                  </Label>
                </Grid>

                <Grid item xs={3}>
                  <SelectField
                    label={t('modals.filters.create.consultsTargets.label')}
                    items={consultsTargetsOptions}
                    value={selectedConsultsTargetsOption}
                    onChange={e => setSelectedConsultsTargetsOption(e.target.value)}
                  />
                </Grid>

                {
                  selectedConsultsTargetsOption === true && (
                    <>
                      <Grid item xs={3} md={2}>
                        <SelectField
                          label={t('modals.filters.create.sign.label')}
                          items={signOptions}
                          value={consultsTargetsSign}
                          onChange={e => setConsultsTargetsSign(e.target.value)}
                          style={{ width: '100%' }}
                        />
                      </Grid>
                      <Grid item xs={3} md={2}>
                        <TextField
                          light
                          variant='filled'
                          type='number'
                          label={consultsTargetsSign === 5 ? t('modals.filters.create.sign.minimumQuantity') : t('modals.filters.create.sign.quantity')}
                          value={consultsTargetsNumber}
                          onChange={e => validateConsultsTargetsNumber(e.target.value, 1)}
                          error={consultsTargetsError}
                          helperText={consultsTargetsHelperText}
                          style={{ width: '100%' }}
                        />
                      </Grid>
                      {
                        consultsTargetsSign === 5 && (
                          <Grid item xs={3} md={2}>
                            <TextField
                              light
                              variant='filled'
                              type='number'
                              label={t('modals.filters.create.sign.maximumQuantity')}
                              value={consultsTargetsNumber2}
                              onChange={e => validateConsultsTargetsNumber(e.target.value, 2)}
                              disabled={consultsTargetsNumber.length === 0}
                              error={consultsTargetsNumberError}
                              helperText={consultsTargetsNumberHelperText}
                              style={{ width: '100%' }}
                            />
                          </Grid>
                        )
                      }
                    </>
                  )
                }

              </Grid>
            )
          }

          {/** About consults date */}
          {
            selectedConsultsOption !== 0 && (
              <Grid container spacing={2} item xs={12}>

                <Grid item xs={2}>
                  <Label v='body2'>
                    {t('modals.filters.create.consultsDate.label')}
                  </Label>
                </Grid>

                <Grid item xs={3}>
                  <SelectField
                    label={t('modals.filters.create.consultsDate.label')}
                    items={dateOptions}
                    value={selectedConsultsDateOption}
                    onChange={e => setSelectedConsultsDateOption(e.target.value)}
                  />
                </Grid>

                {
                  selectedConsultsDateOption === 1
                    ? (
                      <>
                        <Grid item xs={3} md={2}>
                          <DatePicker
                            label={t('modals.filters.create.register.begin')}
                            format="dd/MM/yyyy"
                            inputVariant="outlined"
                            maxDate={consultsEnd}
                            value={consultsBegin}
                            onChange={e => setConsultsBegin(e)}
                            showTodayButton
                            todayLabel={t('modals.notifications.create.validUntil.today')}
                            required
                            style={{ width: '100%' }}
                          />
                        </Grid>
                        <Grid item xs={3} md={2}>
                          <DatePicker
                            label={t('modals.filters.create.register.end')}
                            format="dd/MM/yyyy"
                            inputVariant="outlined"
                            minDate={consultsBegin}
                            disableFuture
                            value={consultsEnd}
                            onChange={e => setConsultsEnd(e)}
                            showTodayButton
                            todayLabel={t('modals.notifications.create.validUntil.today')}
                            required
                            style={{ width: '100%' }}
                          />
                        </Grid>
                      </>
                    )
                    : selectedConsultsDateOption === 2 && (
                      <Grid item xs={3} md={2}>
                        <TextField
                          light
                          variant='filled'
                          type='number'
                          label={t('modals.filters.create.register.days')}
                          value={consultsLastDays}
                          error={consultsLastDaysError}
                          helperText={consultsLastDaysHelperText}
                          onChange={e => validateConsultsDays(e.target.value)}
                          style={{ width: '100%' }}
                        />
                      </Grid>
                    )
                }

              </Grid>
            )
          }

          {/** About credit purchases */}
          <Grid container spacing={2} item xs={12}>

            <Grid item xs={2}>
              <Label v='body2'>
                {t('modals.filters.create.creditPurchase.label')}
              </Label>
            </Grid>

            <Grid item xs={3}>
              <SelectField
                label={t('modals.filters.create.creditPurchase.label')}
                items={creditPurchasesOptions}
                value={selectedCreditPurchasesOption}
                onChange={e => setSelectedCreditPurchasesOption(e.target.value)}
              />
            </Grid>

            {
              selectedCreditPurchasesOption === 1 && (
                <>
                  <Grid item xs={3} md={2}>
                    <SelectField
                      label={t('modals.filters.create.sign.label')}
                      items={signOptions}
                      value={creditPurchasesSign}
                      onChange={e => setCreditPurchasesSign(e.target.value)}
                      style={{ width: '100%' }}
                    />
                  </Grid>
                  <Grid item xs={3} md={2}>
                    <CurrencyTextField
                      label={creditPurchasesSign === 5 ? t('modals.filters.create.creditPurchase.minimumValue') : t('modals.filters.create.creditPurchase.value')}
                      textAlign="left"
                      variant="filled"
                      outputFormat="number"
                      currencySymbol="R$"
                      decimalCharacter=","
                      digitGroupSeparator="."
                      minimumValue="0"
                      value={creditPurchasesValue}
                      onChange={(_, value) => validateCreditPurchasesValue(value, 1)}
                      style={{ width: '100%' }}
                    />
                  </Grid>
                  {
                    creditPurchasesSign === 5 && (
                      <Grid item xs={3} md={2}>
                        <CurrencyTextField
                          label={t('modals.filters.create.creditPurchase.maximumValue')}
                          textAlign="left"
                          variant="filled"
                          outputFormat="number"
                          currencySymbol="R$"
                          decimalCharacter=","
                          digitGroupSeparator="."
                          minimumValue="0"
                          value={creditPurchasesValue2}
                          onChange={(_, value) => validateCreditPurchasesValue(value, 2)}
                          error={creditPurchasesValueError}
                          helperText={creditPurchasesValueHelperText}
                          disabled={creditPurchasesValue.length === 0 || creditPurchasesValue === 0}
                          style={{ width: '100%' }}
                        />
                      </Grid>
                    )
                  }
                </>
              )
            }

          </Grid>

          {/** About credit purchases date */}
          {
            selectedCreditPurchasesOption !== 0 && (
              <Grid container spacing={2} item xs={12}>
                <Grid item xs={2}>
                  <Label v='body2'>
                    {t('modals.filters.create.creditPurchaseDate.label')}
                  </Label>
                </Grid>
                <Grid item xs={3}>
                  <SelectField
                    label={t('modals.filters.create.creditPurchaseDate.label')}
                    items={dateOptions}
                    value={selectedCreditPurchasesDateOption}
                    onChange={e => setSelectedCreditPurchasesDateOption(e.target.value)}
                  />
                </Grid>

                {
                  selectedCreditPurchasesDateOption === 1
                    ? (
                      <>
                        <Grid item xs={3} md={2}>
                          <DatePicker
                            label={t('modals.filters.create.register.begin')}
                            format="dd/MM/yyyy"
                            inputVariant="outlined"
                            maxDate={creditPurchasesEnd}
                            value={creditPurchasesBegin}
                            onChange={e => setCreditPurchasesBegin(e)}
                            showTodayButton
                            todayLabel={t('modals.notifications.create.validUntil.today')}
                            required
                            style={{ width: '100%' }}
                          />
                        </Grid>
                        <Grid item xs={3} md={2}>
                          <DatePicker
                            label={t('modals.filters.create.register.end')}
                            format="dd/MM/yyyy"
                            inputVariant="outlined"
                            minDate={creditPurchasesBegin}
                            disableFuture
                            value={creditPurchasesEnd}
                            onChange={e => setCreditPurchasesEnd(e)}
                            showTodayButton
                            todayLabel={t('modals.notifications.create.validUntil.today')}
                            required
                            style={{ width: '100%' }}
                          />
                        </Grid>
                      </>
                    )
                    : selectedCreditPurchasesDateOption === 2 && (
                      <Grid item xs={3} md={2}>
                        <TextField
                          light
                          variant='filled'
                          type='number'
                          label={t('modals.filters.create.register.days')}
                          value={creditPurchasesLastDays}
                          error={creditPurchasesLastDaysError}
                          helperText={creditPurchasesLastDaysHelperText}
                          onChange={e => validateCreditPurchasesDays(e.target.value)}
                          style={{ width: '100%' }}
                        />
                      </Grid>
                    )
                }

              </Grid>

            )
          }

          {/** About RD Station event */}
          <Grid item xs={12}>
            <Divider className={classes.divider} />
          </Grid>

          <Grid item xs={12}>
            <Label v='h6'>{t('modals.filters.create.rdEvents.title')}</Label>
          </Grid>

          <Grid container spacing={2} item xs={12}>

            <Grid item xs={2}>
              <Label v='body2'>
                {t('modals.filters.create.rdEvents.label')}
                <Tooltip title={t('modals.filters.create.rdEvents.tooltip')} placement="right" style={{ marginLeft: '5px' }}>
                  <InfoOutlined fontSize='small' />
                </Tooltip>
              </Label>
            </Grid>

            <Grid item xs={3}>
              <SelectField
                label={t('modals.filters.create.rdEvents.label')}
                items={rdEventOptions}
                value={selectedRdEventOption}
                onChange={e => setSelectedRdEventOption(e.target.value)}
              />
            </Grid>

            {
              selectedRdEventOption === 1 && (
                <Grid item xs={7}>
                  <TextField
                    light
                    variant='filled'
                    type='text'
                    label={t('modals.filters.create.rdEvents.name')}
                    value={rdEventName}
                    style={{ width: '100%' }}
                    inputProps={{
                      readOnly: true
                    }}
                  />
                </Grid>
              )
            }

          </Grid>

          {/** About RD Station events enter condition */}
          {/**
            selectedRdEventOption === 1 && (
              <Grid container spacing={2} item xs={12}>

                <Grid item xs={2}>
                  <Label v='body2'>
                    {t('modals.filters.create.rdEventsEnter.label')}
                    <Tooltip title={t('modals.filters.create.rdEventsEnter.tooltip')} placement="right" style={{ marginLeft: '5px' }}>
                      <InfoOutlined fontSize='small' />
                    </Tooltip>
                  </Label>
                </Grid>

                <Grid item xs={3}>
                  <SelectField
                    label={t('modals.filters.create.rdEventsEnter.label')}
                    items={rdEventEnterOptions}
                    value={selectedRdEventEnterOption}
                    onChange={e => setSelectedRdEventEnterOption(e.target.value)}
                  />
                </Grid>

                {
                  selectedRdEventEnterOption === 0 ? (
                    <Grid item xs={7}>
                      <Label>
                        {t('modals.filters.create.rdEventsEnter.newUsersExplanation')}
                      </Label>
                    </Grid>
                  ) : (
                    <Grid item xs={7}>
                      <Label>
                        {t('modals.filters.create.rdEventsEnter.allUsersExplanation')}
                      </Label>
                    </Grid>
                  )

                }

              </Grid>
            )
          */}

          {/** About RD Station events trigger frequency */}
          {
            selectedRdEventOption === 1 && (
              <Grid container spacing={2} item xs={12}>

                <Grid item xs={2}>
                  <Label v='body2'>
                    {t('modals.filters.create.rdEventsTriggerFrequency.label')}
                    <Tooltip title={t('modals.filters.create.rdEventsTriggerFrequency.tooltip')} placement="right" style={{ marginLeft: '5px' }}>
                      <InfoOutlined fontSize='small' />
                    </Tooltip>
                  </Label>
                </Grid>

                <Grid item xs={3}>
                  <SelectField
                    label={t('modals.filters.create.rdEventsTriggerFrequency.label')}
                    items={rdEventTriggerFrequencyOptions}
                    value={selectedRdEventTriggerFrequencyOption}
                    onChange={e => setSelectedRdEventTriggerFrequencyOption(e.target.value)}
                  />
                </Grid>

                {
                  selectedRdEventTriggerFrequencyOption === 1 && (
                    <Grid item xs={3} md={2}>
                      <TextField
                        light
                        variant='filled'
                        type="number"
                        min={0}
                        label={t(`modals.filters.create.rdEventsTriggerFrequency.interval`)}
                        value={rdEventTriggerFrequencyInterval}
                        error={rdEventTriggerFrequencyIntervalError}
                        helperText={rdEventTriggerFrequencyIntervalHelperText}
                        onChange={e => validateRdEventTriggerFrequencyInterval(e.target.value)}
                        style={{ width: '100%' }}
                      />
                    </Grid>
                  )
                }

              </Grid>
            )
          }

          {/** About RD Station event trigger initial date  */}
          {
            selectedRdEventOption === 1 && (
              <Grid container spacing={2} item xs={12}>

                <Grid item xs={2}>
                  <Label v='body2'>
                    {t('modals.filters.create.rdEventsTriggerInitialDate.label')}
                    <Tooltip title={t('modals.filters.create.rdEventsTriggerInitialDate.tooltip')} placement="right" style={{ marginLeft: '5px' }}>
                      <InfoOutlined fontSize='small' />
                    </Tooltip>
                  </Label>
                </Grid>

                <Grid item xs={3}>
                  <SelectField
                    label={t('modals.filters.create.rdEventsTriggerInitialDate.label')}
                    items={rdEventTriggerBeginOptions}
                    value={selectedRdEventTriggerBeginOption}
                    onChange={e => setSelectedRdEventTriggerBeginOption(e.target.value)}
                  />
                </Grid>

                {
                  selectedRdEventTriggerBeginOption === 1 && (
                    <Grid item xs={3} md={2}>
                      <DatePicker
                        label={t('modals.filters.create.register.date')}
                        inputVariant="outlined"
                        format="dd/MM/yyyy"
                        value={rdEventTriggerBeginDate}
                        onChange={e => setRdEventTriggerBeginDate(e)}
                        disablePast
                        minDate={today().add(2, 'days')}
                        required
                        style={{ width: '100%' }}
                      />
                    </Grid>
                  )
                }

              </Grid>
            )
          }

          {/** Error Alert */}
          {
            editFilterError && (
              <Grid item xs={12}>
                <Alert color="error" text={t('modals.filters.edit.error')} />
              </Grid>
            )
          }

          {/** Footer */}
          <Grid container justify='flex-end' alignItems='center' item xs={12}>

            <Grid item>
              <CleanButton onClick={onClose} style={{ marginRight: '15px' }}>
                {t('default.cancel')}
              </CleanButton>
            </Grid>

            <Grid item>
              <PrimaryButton onClick={editFilter}>
                {
                  editingFilter ? (
                    <Loader />
                  ) : (
                    t('modals.filters.edit.confirmButton')
                  )
                }
              </PrimaryButton>
            </Grid>

          </Grid>

        </Grid>

      </Paper>
    </Modal>
  )
}

EditFilterModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  close: PropTypes.func
}

EditFilterModal.defaultProps = {
  open: false,
  onClose: () => true,
  close: () => true
}

const styles = theme => ({
  root: {
    position: 'absolute',
    padding: theme.spacing(2)
  },
  modalDiv: {
    [theme.breakpoints.up('md')]: {
      width: '80%'
    },
    width: '100%',
    top: '10%',
    left: '50%',
    transform: 'translate(-50%, -10%)',
  },
  divider: {
    background: theme.palette.primary.main,
    marginTop: '0.5rem'
  }
})

const mapStateToProps = ({ ReducerFilter, ReducerPlan }) => ({
  editFilterError: ReducerFilter.editFilterError,
  editingFilter: ReducerFilter.editingFilter,
  plans: ReducerPlan.plans,
  loadingPlans: ReducerPlan.loadingPlans
})

export default connect(mapStateToProps)(withStyles(styles)(EditFilterModal))